// extracted by mini-css-extract-plugin
export var TableCodeWrapper = "index-module--TableCodeWrapper--34f3b";
export var TableIcon = "index-module--TableIcon--4fe09";